<p-toast position="top-right" key="notification-toast">
  <ng-template let-content pTemplate="content">
    <!-- <span
      [class]="'pt-1 p-message-icon ' + content.icon"
    ></span> -->
    <div class="p-toast-message-text ml-0">
      <div class="p-toast-summary">{{ content.summary | i18next | uppercase }}</div>
      <div class="p-toast-detail" style="overflow-wrap: anywhere;" [innerHTML]="content.detail"></div>
      <button
        *ngIf="content.rawDetails"
        type="button"
        class="toast-copy-button"
        (click)="copyDetails(content.rawDetails)"
      >
        Másolás
      </button>
    </div>
  </ng-template>
</p-toast>
